import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    companyName: '', userName: '', email: '', password: '',
    acceptTerms: false, marketingSubscribed: true,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!form.acceptTerms) { setError('Az ÁSZF és az Adatkezelési Tájékoztató elfogadása kötelező.'); return; }
    setLoading(true);
    try {
      await register(form);
      navigate('/onboarding/company');
    } catch (err: any) {
      setError(err.message || 'Regisztrációs hiba.');
    } finally { setLoading(false); }
  };

  const set = (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, [key]: e.target.value });

  return (
    <div className="auth-bg">
      <div className="auth-card">
        <div className="auth-head">
          <div className="auth-logo">
            <svg width="32" height="32" viewBox="0 0 100 100">
              <path d="M16 88 L16 40 L50 64" fill="none" stroke="#14233F" strokeWidth="17" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M50 64 L84 16 L84 64" fill="none" stroke="#F47B20" strokeWidth="17" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Regisztráció</span>
          </div>
          <p className="auth-sub">Az első hónap ingyenes, bankkártya nélkül.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="form-label">Cégnév *</label>
            <input className="form-input" value={form.companyName} onChange={set('companyName')} required placeholder="Példa Kft." />
          </div>
          <div className="auth-field">
            <label className="form-label">Teljes név *</label>
            <input className="form-input" value={form.userName} onChange={set('userName')} required placeholder="Vezetéknév Keresztnév" />
          </div>
          <div className="auth-field">
            <label className="form-label">E-mail cím *</label>
            <input className="form-input" type="email" value={form.email} onChange={set('email')} required placeholder="pelda@ceg.hu" />
          </div>
          <div className="auth-field">
            <label className="form-label">Jelszó * (min. 8 karakter)</label>
            <input className="form-input" type="password" value={form.password} onChange={set('password')} required minLength={8} placeholder="Jelszó" />
          </div>

          <label className="auth-checkbox">
            <input type="checkbox" checked={form.acceptTerms} onChange={e => setForm({ ...form, acceptTerms: e.target.checked })} />
            <span>
              Elolvastam és elfogadom az{' '}
              <a href="/aszf" target="_blank">Általános Szerződési Feltételeket</a>
              {' '}és az{' '}
              <a href="/adatkezeles" target="_blank">Adatkezelési Tájékoztatót</a>. *
            </span>
          </label>

          <label className="auth-checkbox">
            <input type="checkbox" checked={form.marketingSubscribed} onChange={e => setForm({ ...form, marketingSubscribed: e.target.checked })} />
            <span>Szeretnék értesülni az újdonságokról és kedvezményekről.</span>
          </label>

          {error && <div className="auth-error">{error}</div>}

          <button type="submit" disabled={loading} className="btn btn-primary" style={{ width: '100%', padding: '12px', fontSize: '15px', marginTop: '8px', opacity: loading ? .6 : 1 }}>
            {loading ? 'Regisztráció...' : 'Ingyenes próba indítása'}
          </button>
        </form>

        <div className="auth-footer">
          Már van fiókod? <Link to="/bejelentkezes">Bejelentkezés</Link>
        </div>
      </div>
    </div>
  );
}
